import { render, staticRenderFns } from "./FCDashboardNewAssignmentItem.vue?vue&type=template&id=72bd9cf8&scoped=true&"
import script from "./FCDashboardNewAssignmentItem.vue?vue&type=script&lang=js&"
export * from "./FCDashboardNewAssignmentItem.vue?vue&type=script&lang=js&"
import style0 from "./FCDashboardNewAssignmentItem.vue?vue&type=style&index=0&id=72bd9cf8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72bd9cf8",
  null
  
)

export default component.exports